import React from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { classNames } from "../../../helpers/classNames";
import { Link } from "react-router-dom";

const TableAction = ({
  data,
  xPlacement = "left",
  dropdownContainer,
  flip = true,
  buttonClass,
  ...props
}) => {
  return (
    <Menu as="div">
      <MenuButton className="flex items-center justify-center">
        <div
          className={classNames(
            "relative text-base text-org-grayB bg-white shadow w-6 h-6 flex items-center justify-center focus:ring-0 transition-all duration-200 rounded-md hover:bg-org-silver hover:text-org-darkGray",
            buttonClass
          )}
        >
          <i className="fa-regular fa-fw fa-ellipsis-vertical"></i>
        </div>
      </MenuButton>

      <MenuItems
        transition
        anchor={xPlacement}
        className={classNames(
          "absolute mt-1 [--anchor-gap:4px] [--anchor-offset:10px] border border-org-border w-40 origin-top-right rounded-md bg-white shadow-lg focus:outline-none py-1",
          dropdownContainer
        )}
      >
        <div className="py-1 max-h-80 overflow-auto scroll-smooth scrollbar">
          {data.length > 0 &&
            data?.map((item, i) => {
              return (
                <React.Fragment key={i}>
                  {item.link ? (
                    <MenuItem>
                      <Link
                        to={item.link}
                        className={classNames(
                          "group flex w-full items-center px-3 py-1.5 text-sm gap-2 transition-all duration-200   ",
                          // active
                          //   ? "bg-org-veryLightBlue text-org-blue"
                          //   : "text-org-grayB",
                          item?.class
                        )}
                      >
                        {item.icon && (
                          <i className={classNames("fa-fw", item.icon)}></i>
                        )}
                        <span>{item.name}</span>
                      </Link>
                    </MenuItem>
                  ) : (
                    <MenuItem>
                      <button
                        type="button"
                        className={classNames(
                          "group flex w-full items-center px-3 py-1.5 text-sm gap-2 transition-all duration-200  ",
                          // active
                          //   ? "bg-opplio-veryLightBlue text-red-400"
                          //   : "text-opplio-grayB",
                          item?.standout
                            ? "!text-opplio-red hover:!bg-opplio-red/10"
                            : "",
                          item?.class
                        )}
                        onClick={item?.onClick}
                      >
                        {item?.icon && (
                          <i className={classNames("fa-fw", item?.icon)}></i>
                        )}
                        <span>{item?.name}</span>
                      </button>
                    </MenuItem>
                  )}
                </React.Fragment>
              );
            })}
        </div>
      </MenuItems>
    </Menu>
  );
};

export default TableAction;
